import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    * {
        padding: 0;
        margin: 0;
        list-style: none;
        text-decoration: none;
        box-sizing: border-box;
    }

    html { 
        background-color: #eee;
        scroll-behavior: smooth;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:focus {
        transition: background-color 0s 600000s, color 0s 600000s !important;
    }

    .mp-autocomplete-fragment {
        color: #7f7f7f;
    }

`;
